import React, { useContext } from "react";
import { EntityProfileContext } from ".";
import { datesToDuration } from "../../../../../utils/dateAndTime";
import {
    extractResourceAttributes,
    mapResourceObjectToArray,
} from "../../../../../utils/jsonApiUtils";
import TripDetailsSection from "../../../../trips/components/Summary/TripDetailsSection";

function ProfileDetailsField({ field }) {
    const { entity, includedResource, onSubmit, onEntityUpdate } = useContext(EntityProfileContext);

    const includedEntity =
        field.type === "attachment"
            ? mapResourceObjectToArray(includedResource[field.entityName])
            : extractResourceAttributes(includedResource[field.entityName]);
    const isIncludedEntityField = !!field.includeEntityName;
    const fieldEntity = isIncludedEntityField ? includedEntity : entity;

    let fieldValue;

    if (field.type === "duration") {
        const { start, end } = {
            start: fieldEntity[field.durationFields[0]],
            end: fieldEntity[field.durationFields[1]],
        };

        fieldValue = datesToDuration(start, end);
    } else if (field.type === "attachment") {
        fieldValue = includedEntity;
    } else {
        fieldValue = fieldEntity[field.filterValue || field.name];
    }

    return (
        <TripDetailsSection
            label={field.label}
            options={field}
            selectedValue={fieldValue}
            onSave={(dataToSubmit, callback) =>
                field.updateEntityOnChange
                    ? onEntityUpdate(
                          {
                              entityName: field.entityName,
                              entityId: includedEntity.id,
                              attributes: dataToSubmit,
                          },
                          callback
                      )
                    : onSubmit(dataToSubmit, callback)
            }
            isEditable={field.isEditable}
            onSelectChange={onSubmit}
        />
    );
}

export default ProfileDetailsField;
